import { TextInput as AntdTextInput } from "@empglabs/backoffice-ui-kit"
import { forwardRef } from "react"

const TextInput = forwardRef((props, ref) => {
  return <AntdTextInput ref={ref} {...props} />
})

export default TextInput
